import React, { useEffect, useState, useRef } from 'react';
import { ApiCore } from '../../api';
import styles from './homeScale.module.scss';
import utils from '../../utils/utils';
const api = new ApiCore();

function HomeScale(props: any) {

    useEffect(() => {
        document.title = '工具详情';
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        innerHtmlRender();
    }

    const innerHtmlRender = () => {
        const _urlParams = utils.getUrlParams()|| {};
        if (_urlParams.scaleCode) {
            api.getScaleIntroduceDetail({
                scaleCode: _urlParams.scaleCode
            }).then((res: any) => {
                if (res.code == 0) {
                    const _dom = document.getElementById('home_scale_content');
                    if (_dom && res.data.content) {
                        _dom.innerHTML = res.data.content;
                    }
                }
            });
        }
    }


    return (
        <div className={styles.homeScale_content}>
            <div className={styles.content_wrap} id='home_scale_content'></div>
        </div>
    )
}

export default HomeScale;